import type { ReactNode, SVGProps } from 'react'

/**
 * Een niet-actieve sectie met nog openstaande harde controles (c2, R-157).
 *
 * Geen apart icoon voor "nog niet begonnen" versus "begonnen maar niet compleet": `evaluate()`
 * (`packages/engine`) houdt dat onderscheid niet bij, alleen of er nog harde controles openstaan.
 * Dat verzinnen zou nieuwe afleiding vragen voor een zuiver cosmetische werkstroom.
 */
export function CircleIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      style={{ width: 'var(--nwo-space-sp-4)', height: 'var(--nwo-space-sp-4)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
    </svg>
  )
}
